import React from 'react';

import { CategoryLink } from './components/CategoryLink';

import { highlightText } from 'js/app/utils/common.util';
import { prepareTranslateKey } from 'js/app/utils/prepareTranslateKey';
import { useTranslations } from 'js/hooks/i18n';

import style from './CategoryTitle.scss';

export const CategoryTitle = ({ category, targetCategoryName }) => {
    const translate = useTranslations('playtech.mobile.system.buzzGame.');

    return (
        <div className={`${style.titleBar} CategoryTitle__titleBar`}>
            <span
                className={style.title}
                dangerouslySetInnerHTML={{ __html: translate(
                    prepareTranslateKey(category.name),
                    highlightText(category.name))
                }}
            />

            <CategoryLink
                category={category}
                targetCategoryName={targetCategoryName}
            />
        </div>
    );
};
